// 只保留项目中实际使用的函数
export function showError(error) {
  console.error(error);
  if (error.message) {
    if (error.name === "AxiosError") {
      switch (error.response.status) {
        case 401:
          break;
        case 429:
          console.error("错误：请求次数过多，请稍后再试！");
          break;
        case 500:
          console.error("错误：服务器内部错误，请联系管理员！");
          break;
        case 405:
          console.info("本站仅作演示之用，无服务端！");
          break;
        default:
          console.error("错误：" + error.message);
      }
      return;
    }
    console.error("错误：" + error.message);
  } else {
    console.error("错误：" + error);
  }
}

export function timestamp2string(timestamp) {
  let date = new Date(timestamp * 1000);
  let year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  let hour = date.getHours().toString();
  let minute = date.getMinutes().toString();
  let second = date.getSeconds().toString();
  if (month.length === 1) {
    month = "0" + month;
  }
  if (day.length === 1) {
    day = "0" + day;
  }
  if (hour.length === 1) {
    hour = "0" + hour;
  }
  if (minute.length === 1) {
    minute = "0" + minute;
  }
  if (second.length === 1) {
    second = "0" + second;
  }
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
  );
}
